const UNITS = ["B", "KB", "MB", "GB"] as const;

export const formatFileSize = (bytes: number): string => {
  let value = bytes;
  let unitIndex = 0;
  while (value >= 1024 && unitIndex < UNITS.length - 1) {
    value /= 1024;
    unitIndex++;
  }
  return `${unitIndex === 0 ? value : value.toFixed(1)} ${UNITS[unitIndex]}`;
};
